import { render, staticRenderFns } from "./handTodo.vue?vue&type=template&id=1c2e9a4d&scoped=true"
import script from "./handTodo.vue?vue&type=script&lang=js"
export * from "./handTodo.vue?vue&type=script&lang=js"
import style0 from "./handTodo.vue?vue&type=style&index=0&id=1c2e9a4d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2e9a4d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c2e9a4d')) {
      api.createRecord('1c2e9a4d', component.options)
    } else {
      api.reload('1c2e9a4d', component.options)
    }
    module.hot.accept("./handTodo.vue?vue&type=template&id=1c2e9a4d&scoped=true", function () {
      api.rerender('1c2e9a4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderAudit/handTodo.vue"
export default component.exports